import { LOCALES } from 'i18n/locales';

export const featurePanelOpenButtonIntl = {
    [LOCALES.ENGLISH]: {
        'openFeaturePanel.openFeature': 'Open in feature panel',
        'openFeaturePanel.closeFeature': 'Close feature panel'
    },
    [LOCALES.WELSH]: {
        'openFeaturePanel.openFeature': 'Agor yn y panel nodweddion',
        'openFeaturePanel.closeFeature': 'Cau\'r panel nodweddion'
    }
};
